// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"4ba3c33b","940":"98db1613"}[chunkId] + ".chunk.js";
};